import React from "react";
// import { Link } from "react-router-dom";
// import coupleImg1 from "../../images/couple/3.jpg";
import coupleImg2 from "../../images/couple/couple-flower.png";
// import vector1 from "../../images/couple/vector-1.svg";
// import vector2 from "../../images/couple/vector-2.svg";
import { connect } from "react-redux";
import { getCloudinaryFullPath } from "../../utils";
import Hashtag from "../Hashtag/Hashtag";
import { capitalize } from "../../utils/string";
import CoupleHeading from "../CoupleHeading/CoupleHeading";
import { Slide } from "react-awesome-reveal";
import CoupleInfo from "../CoupleInfo/CoupleInfo";

const CoupleSection3 = ({ couplePhoto, bride = {}, groom = {} }) => {
  return (
    <Slide direction="up" duration={1000} triggerOnce>
      <section className="wpo-couple-section-s3 section-padding" id="couple">
        <div className="container-fluid">
          <CoupleHeading />
          <Hashtag />
          <div className="couple-area clearfix">
            <div className="row align-items-center">
              <div className="col col-xl-3 col-lg-4 col-12">
                <div className="text-grid">
                  {/* <div className="vector">
                  <img src={vector1} alt="" />
                </div> */}
                  <CoupleInfo data={groom} isGroom={true} />
                  {/* <div className="social">
                  <ul>
                    <li>
                      <Link to="/home-3">
                        <i className="ti-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/home-3">
                        <i className="ti-twitter-alt"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/home-3">
                        <i className="ti-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div> */}
                </div>
              </div>
              <div className="col col-xl-6 col-lg-4 col-12">
                <div className="middle-couple-pic">
                  <div className="middle-couple-pic-inner">
                    <img src={getCloudinaryFullPath(couplePhoto)} alt="" />
                  </div>
                  <div className="couple-flower">
                    <img src={coupleImg2} alt="" />
                  </div>
                </div>
              </div>
              <div className="col col-xl-3 col-lg-4 col-12">
                <div className="text-grid">
                  {/* <div className="vector">
                  <img src={vector2} alt="" />
                </div> */}
                  <CoupleInfo data={bride} isGroom={false} />
                  {/* <div className="social">
                  <ul>
                    <li>
                      <Link to="/home-3">
                        <i className="ti-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/home-3">
                        <i className="ti-twitter-alt"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/home-3">
                        <i className="ti-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Slide>
  );
};

const mapStateToProps = (state) => {
  return {
    bride: state.inviteDetails.invite?.bride,
    groom: state.inviteDetails.invite?.groom,
    couplePhoto: state.inviteDetails.invite?.couplePhoto,
  };
};
export default connect(mapStateToProps)(CoupleSection3);
